import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IOffice } from '../../store/pik_data/offices';

export enum EOfficesActionTypes {
  InitOffices = 'OFFICES/INIT',
}

export type TInitOffices = ITypedReduxAction<EOfficesActionTypes.InitOffices, IOffice[]>;

export const initOffices: (offices: IOffice[]) => TInitOffices = actionGenerator<
  EOfficesActionTypes.InitOffices,
  IOffice[]
>(EOfficesActionTypes.InitOffices);
